import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { Routes } from "./routes";
import configureStore from "./store.dev";
import "./App.less";
import "antd/dist/antd.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "video-react/dist/video-react.css"; // import css
import ScrollToTop from "./scrollToTop";

const store = configureStore({});

function App() {
  return (
    <Provider store={store}>
      <div>
        <Router>
          <ScrollToTop />
          <Switch>
            <Routes />
            <ToastContainer limit={2} />
          </Switch>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
